import { useState } from "react"
import { router } from "@inertiajs/react"
import { StepShell } from "../components/StepShell"
import { Clock, Heart, Target } from "lucide-react"

export function Welcome({ currentUser, wizard }) {
  const [processing, setProcessing] = useState(false)
  const isPeerGroup = wizard.mode.key === "peer_group"
  const isGoalsOnly = wizard.mode.key === "goals_only"

  // PATCH so the server can advance `furthest_step` — without this the
  // user's progress through the non-persistent intro steps isn't tracked
  // and the next visit drops them back to welcome (or worse, straight
  // into the Life Audit, depending on what the wizard resumes to).
  const goNext = () => {
    setProcessing(true)
    router.patch(
      "/app/plan/intake",
      { step: "welcome", advance: "1" },
      {
        preserveScroll: true,
        onFinish: () => setProcessing(false),
      },
    )
  }

  return (
    <StepShell
      title={`Welcome, ${currentUser?.name?.split(" ")[0] || "friend"}`}
      subtitle={
        isPeerGroup
          ? "A quick look at what's ahead — it only takes about 10–15 minutes."
          : isGoalsOnly
            ? "We'll build your annual plan together — no assessment required."
            : "A quick overview of what we'll walk through together."
      }
      onNext={goNext}
      nextLabel="Let's begin"
      processing={processing}
    >
      <ul className="space-y-4">
        <li className="flex items-start gap-3">
          <Clock className="w-5 h-5 text-kf-red shrink-0 mt-0.5" />
          <div>
            <p className="font-medium text-zinc-900">
              {isPeerGroup || isGoalsOnly ? "About 10–15 minutes" : "About 15–20 minutes"}
            </p>
            <p className="text-sm text-zinc-600">
              You can pause anytime — we'll pick up where you left off.
            </p>
          </div>
        </li>
        <li className="flex items-start gap-3">
          <Target className="w-5 h-5 text-kf-red shrink-0 mt-0.5" />
          <div>
            <p className="font-medium text-zinc-900">
              {isPeerGroup
                ? "The Integrated Life Audit + a few questions"
                : isGoalsOnly
                  ? "Goals, one-year plan, KPIs, and quarterly rocks"
                  : "Integrated Life Audit, goals, one-year plan, rocks"}
            </p>
            <p className="text-sm text-zinc-600">
              {isPeerGroup
                ? "A snapshot across six areas of life, then a few questions about your business and goals."
                : isGoalsOnly
                  ? "The planning framework without the Integrated Life Audit — you can complete it anytime from your dashboard."
                  : "The same framework current Kingdom Factor Members use."}
            </p>
          </div>
        </li>
        <li className="flex items-start gap-3">
          <Heart className="w-5 h-5 text-kf-red shrink-0 mt-0.5" />
          <div>
            <p className="font-medium text-zinc-900">
              {isGoalsOnly ? "Your plan, live on your dashboard" : "Personalized report"}
            </p>
            <p className="text-sm text-zinc-600">
              {isPeerGroup
                ? "At the end you'll get a report on how a Christian business peer group could help you — and your coach will follow up."
                : isGoalsOnly
                  ? "When you finish, your goals, KPIs, and rocks land straight on your dashboard scorecard."
                  : "At the end, you'll receive a narrative report your coach will discuss with you."}
            </p>
          </div>
        </li>
      </ul>
    </StepShell>
  )
}
